import {
  Col,
  ColType,
  Crud,
  CrudOption,
  CrudApi,
  CrudAction,
} from "../../comp/crud";
import { formatDate,formatDateTime } from "../../utils";
import { IconModalStroked } from "@douyinfe/semi-icons";
import { Modal, Typography, Toast } from "@douyinfe/semi-ui";
import { ApiClient } from "../../api/ApiClient";
import React, { useEffect, useMemo, useState } from "react";
import { TextCell } from "../../comp/cell";
import { displayStar } from "../../utils";

const getFeedbackResultOpts = async (): Promise<CrudOption[]> => {
  const statusOpts: any = [
    {
      label: "成功",
      value: "1",
      key: 1,
    },
    {
      label: "失败",
      value: "0",
      key: 0,
    },
  ];
  return statusOpts;
};

export default function LeadFeedbackLog() {
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);

  let apiClient = ApiClient.getDefault();
  let rootPri = false;
  const role = localStorage.getItem("role");
  if (role == "root" || role == "op_manager") {
    rootPri = true;
  } else {
    rootPri = false;
  }

  let cols: Col[] = [
    {
      name: "客户ID",
      key: "leadId",
      hideInList: false,
      showInFilter: true,
      type: ColType.STRING,
    },
    {
      name: "客户姓名",
      key: "leadName",
      hideInList: false,
      showInFilter: true,
      type: ColType.STRING,
    },
    {
      name: "城市",
      key: "city",
      showInFilter: true,
      hideInList: false,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
    },
    {
      name: "渠道",
      key: "source",
      showInFilter: true,
      type: ColType.STRING,
    },
    {
      name: "当前星级",
      key: "star",
      showInFilter: true,
      hideInList: false,
      render: (a) => displayStar(a),
      getOptions: () =>
        Promise.resolve([
          { label: "0星", value: "0", key: "0" },
          { label: "1星", value: "1", key: "1" },
          { label: "2星", value: "2", key: "2" },
          { label: "3星", value: "3", key: "3" },
          { label: "4星", value: "4", key: "4" },
          { label: "5星", value: "5", key: "5" },
        ]),
      type: ColType.SELECT,
    },
    {
      name: "入库时间",
      key: "leadCreatedAt",
      showInFilter: true,
      hideInList: false,
      type: ColType.DATE_RANGE,
    },
     {
      name: "是否成功",
      key: "feedbackResult",
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: () => getFeedbackResultOpts(),
      render: (value, index) => {
        if (value == 0) {
          return <Typography.Text type="danger">{"失败"}</Typography.Text>;
        } else if (value == 1) { 
          return <Typography.Text type="success">{"成功"}</Typography.Text>;
        }else{
          return <Typography.Text >{"无反馈"}</Typography.Text>;
        }
      },
    },
{
      name: "反馈星级",
      key: "feedbackStar",
      showInFilter: true,
      type: ColType.STRING,
    },
   

   
    
    {
      name: "星级反馈时间",
      key: "updatedAt",
      showInFilter: true,
      hideInList: false,
      type: ColType.DATE_RANGE,
    },
     {
      name: "结果描述",
      key: "feedbackResultMsg",
      showInFilter: false,
      type: ColType.STRING,
      render: (a) => <TextCell width={200} text={a} />,
    },
  ];

  let nowDate = new Date();
  const initFilterValues = {
    leadCreatedAt: [nowDate, nowDate],
  };

  let startDateStr = formatDate(nowDate);
  let endDateStr = formatDate(nowDate);
  const initParams = {
     leadCreatedAt: startDateStr + "," + endDateStr,
  };

  const doFeedbackStar = (row: any, rows: any) => {
    if (rows && rows.length == 0) {
      //如果未选择客户
      Toast.info("请选择客户来操作");
      return;
    }
    Modal.confirm({
      title: "是否反馈星级？该操作会调用渠道接口反馈星级。",
      content: "",
      onOk: async () => {
        try {
          let leadIds = rows.map((row: any) => row.leadId);
          await apiClient.request<boolean>(
            "/leadFeedbackLog/feedbackStar",
            "POST",
            null,
            { leadIds: leadIds }
          );
          Toast.info("星级反馈完成");

          crudApi?.refresh();
        } catch (e) {}
      },
    });
  };
  const actions: CrudAction[] = [];
  const feedbackStarAction: CrudAction = {
    name: "反馈星级",
    action: doFeedbackStar,
  };
  actions.push(feedbackStarAction);

  return (
    <>
      <Crud
        getCrudApi={(crudApi) => {
          setCrudApi(crudApi);
        }}
        canUpdate={false}
        canCreate={false}
        select={true}
        name="客户星级反馈"
        entityKey="leadFeedbackLog"
        initFilterValues={initFilterValues}
        initParams={initParams}
        actions={actions}
        pageSize={50}
        cols={cols}
      />
    </>
  );
}
